import React from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { Hero } from './components/Hero';
import { SalesVideo } from './components/SalesVideo';
import { PainHook } from './components/PainHook';
import { Solution } from './components/Solution';
import { Testimonials } from './components/Testimonials';
import { ValueStack } from './components/ValueStack';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { CtaButton } from './components/CtaButton';
import { PRECIO_HOY } from './data/oferta';
export function App() {
  return <div className="w-full min-h-full bg-white" data-id="element-0" data-mp="31aqfgfhzusqq">
      <UrgencyBar data-id="element-1" data-mp="31bia9o3romfy" />
      <main data-id="element-2" data-mp="31c1iue7j1yhb">
        <Hero data-id="element-3" data-mp="31cjnnz899l0u" />
        <SalesVideo data-id="element-4" data-mp="2wk06yte9u9rt" />
        <PainHook data-id="element-5" data-mp="2wjqhd6x524mn" />
        <Solution data-id="element-6" data-mp="2wj8dbo48im46" />
        <Testimonials data-id="element-7" data-mp="2wip7v6vrtq71" />
        <ValueStack data-id="element-8" data-mp="2wi5pxq64f1t0" />
        <Guarantee data-id="element-9" data-mp="28tw5osok2m3z" />
        <Faq data-id="element-10" data-mp="28te2td7e19n3" />

        <section className="w-full bg-paper-soft py-14 sm:py-16" data-id="element-11" data-mp="28suu8n3mnxlq">
          <div className="mx-auto flex max-w-3xl flex-col items-center px-5 text-center" data-id="element-12" data-mp="23vulg4fe8gqx">
            <h2 className="text-2xl font-black leading-tight tracking-tight text-ink sm:text-[2rem]" data-id="element-13" data-mp="3ikh8ubu2yx01">
              Esta noche puede ser la última que pases revisando cabezas.
            </h2>
            <CtaButton className="mt-8" data-id="element-14" data-mp="3rcj7c4kla37o">
              👉 Empezar ahora por {PRECIO_HOY}
            </CtaButton>
          </div>
        </section>
      </main>

      <footer className="w-full border-t border-paper-line bg-white py-8" data-id="element-15" data-mp="56lvdcob3ly">
        <div className="mx-auto max-w-5xl px-5 text-center text-xs leading-relaxed text-ink-muted" data-id="element-16" data-mp="2zmepackaxs9m">
          <p data-id="element-17" data-mp="33ngee0ki8nxv">
            Megapack Adiós Piojos 2026 — Producto digital de acceso inmediato. Este
            material es informativo y no sustituye la consulta pediátrica.
          </p>
          <p className="mt-2" data-id="element-18" data-mp="3dlw6o6v9q38y">© 2026 Adiós Piojos. Todos los derechos reservados.</p>
        </div>
      </footer>
    </div>;
}